export enum CartNotificationAction {
    LINE_ITEM_QTY_UPDATE = 'cart.lineItem.qtyUpdate',
    LINE_ITEM_AUTOSHIP_REMOVED = 'cart.lineItem.autoshipRemoved',
}
